import { Route } from 'vue-router';
import { NavigationGuardNext } from 'vue-router/types/router';
import store from '@/store';
import { RouteName } from '@/router/types';

export function settingsGuard(to: Route, from: Route, next: NavigationGuardNext): boolean {
  if (!store.getters['tenant/isSettingsAvailable']) {
    next({ name: RouteName.Community });
  } else {
    next();
  }
  return true;
}
